import { HouseIcon } from 'lucide-react';

export const HomeIcon = HouseIcon;
